import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import { Box, Button, Stack, Tooltip, Typography } from '@mui/material';
import { PaymentStatus } from 'constants/pay.constants';

type PaymentConfirmationButtonProps = {
	row: any;
	isMobile: boolean;
	isExportBusy: boolean;
	label: string;
	disabledHint: string;
	onExport: (paymentId: number, reference: string) => void;
};

export default function PaymentConfirmationButton(props: PaymentConfirmationButtonProps) {
	const { row, isMobile, isExportBusy, label, disabledHint, onExport } = props;
	if (!row?.isPaymentRow) {
		return null;
	}

	const canDownload = row.paymentStatusRaw === PaymentStatus.Completed;
	const icon = (
		<FileDownloadOutlined sx={{ fontSize: 16, color: canDownload ? '#fff' : '#95afb1' }} />
	);
	const button = (
		<Button
			className="hiddenActions"
			variant="contained"
			disableElevation
			fullWidth={isMobile}
			disabled={!canDownload || isExportBusy}
			onClick={() => {
				if (canDownload && !isExportBusy) {
					onExport(row.id, row.reference);
				}
			}}
			sx={{
				borderRadius: '8px',
				textTransform: 'none',
				px: 2,
				py: 1,
				minWidth: isMobile ? '100%' : 0,
				...(canDownload && !isExportBusy
					? {
							backgroundColor: '#004751',
							color: '#fff',
							'&:hover': { backgroundColor: '#003842' },
						}
					: {
							backgroundColor: '#e7edee',
							color: '#95afb1',
						}),
			}}
		>
			<Stack direction="row" alignItems="center" spacing={1}>
				<Typography variant="body5" component="span" color="inherit">
					{label}
				</Typography>
				{icon}
			</Stack>
		</Button>
	);

	if (!canDownload && !isMobile) {
		return (
			<Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
				<Tooltip
					title={
						<Box
							style={{ textAlign: 'center', width: '100%' }}
						>
							{disabledHint}
						</Box>
					}
					placement="top"
					arrow
					componentsProps={{
						tooltip: {
							sx: {
								bgcolor: '#2c3e50',
								color: '#fff',
								fontSize: '12px',
								borderRadius: '10px',
								maxWidth: 280,
							},
						},
						arrow: { sx: { color: '#2c3e50' } },
					}}
				>
					<span>{button}</span>
				</Tooltip>
			</Box>
		);
	}

	if (!canDownload && isMobile) {
		return (
			<Box sx={{ width: '100%' }}>
				{button}
				<Typography variant="caption" sx={{ color: '#95afb1', mt: 1, display: 'block', lineHeight: 1.3 }}>
					{disabledHint}
				</Typography>
			</Box>
		);
	}

	return button;
}
